/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientContractNoticeAndAnnouncementFilterRequest { 
    publishedDateFrom?: number;
    publishedDateTo?: number;
    deliveryDateFrom?: number;
    deliveryDateTo?: number;
    estimatedPurchaseValueFrom?: number;
    estimatedPurchaseValueTo?: number;
    agreementValueFrom?: number;
    agreementValueTo?: number;
    searchText?: string;
    contractAuthorityId?: string;
    contractorId?: string;
    mediumId?: string;
    tagIds?: Array<string>;
    types?: Array<ClientContractNoticeAndAnnouncementFilterRequest.TypesEnum>;
    countries?: Array<ClientContractNoticeAndAnnouncementFilterRequest.CountriesEnum>;
    createdAtFrom?: number;
    createdAtTo?: number;
    noTags?: boolean;
}
export namespace ClientContractNoticeAndAnnouncementFilterRequest {
    export type TypesEnum = 'CONTRACT_NOTICE' | 'E_MARKET' | 'CONCESSION' | 'DEFENSE_AND_SECURITY_LAW' | 'SPECIAL_SERVICES' | 'TECHNICAL_DIALOGUES' | 'CONTRACT_AWARD' | 'CANCELLATION' | 'MODIFICATION' | 'LATEST_DECISION';
    export const TypesEnum = {
        CONTRACTNOTICE: 'CONTRACT_NOTICE' as TypesEnum,
        EMARKET: 'E_MARKET' as TypesEnum,
        CONCESSION: 'CONCESSION' as TypesEnum,
        DEFENSEANDSECURITYLAW: 'DEFENSE_AND_SECURITY_LAW' as TypesEnum,
        SPECIALSERVICES: 'SPECIAL_SERVICES' as TypesEnum,
        TECHNICALDIALOGUES: 'TECHNICAL_DIALOGUES' as TypesEnum,
        CONTRACTAWARD: 'CONTRACT_AWARD' as TypesEnum,
        CANCELLATION: 'CANCELLATION' as TypesEnum,
        MODIFICATION: 'MODIFICATION' as TypesEnum,
        LATESTDECISION: 'LATEST_DECISION' as TypesEnum
    };
    export type CountriesEnum = 'MK' | 'AL' | 'XK';
    export const CountriesEnum = {
        MK: 'MK' as CountriesEnum,
        AL: 'AL' as CountriesEnum,
        XK: 'XK' as CountriesEnum
    };
}